import React, { Component }from 'react'
import { compose} from 'recompose'
import {connect} from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {fetchCanidates} from '../../../../../actions/adminCanidates'
import {SELECTED_CANIDATE} from '../../../../../constants/actionTypes'
//import _ from 'lodash'

const styles = theme => ({
    paper: {
        padding: theme.spacing.unit,
      },
    card: {
        marginBottom: theme.spacing.unit,
        //backgroundColor: 'blue'
        cursor: 'pointer',
        padding: theme.spacing.unit
    },
    cardContent: {
        padding: theme.spacing.unit,
    }
})




class AltCanidateSelect extends Component {
    constructor(props) {
        super(props);
    
        this.state   = {
            prevId: null,
            
        } //this.toggleView = this.toggleView.bind(this)
    }

    componentDidMount() {
        const { onFetchCanidates, canidatesOnWait } = this.props
        onFetchCanidates(canidatesOnWait)
    }
    
    handleOnClick = (id) => {

        // do the style stuff for selected canidate
        if(this.state.prevId != null){
            this.setState({[this.state.prevId]: {}})
            this.setState({prevId: null})
        }
        this.setState({[id]: {color: 'white', backgroundColor: '#3f51b5', border: '1px solid green'}})
        this.setState({prevId: id})
    
        // fetch canidate/user contact details
        //this.props.onSelectCanidate(id)
        //this.props.toggleCanidateDetails()
        this.props.handleAltCanidateSelect(id)
        
        }
        renderCanidates = () =>{
            const { canidates, classes } = this.props
    
            return (
                canidates.map((canidate, key) => {
                        if(typeof(this.props.connectedCanidate)!=='undefined' && canidate.id===this.props.connectedCanidate.id) {
                          return null
                        }
                       return  (
                            <Card
                                style={this.state[canidate.id]}
                                key={canidate.id}
                                className={classes.card}
                                onClick={()=>this.handleOnClick(canidate.id)}
                            >
                                <Typography color='inherit' variant='subheading'>
                                    {canidate.name}
                                </Typography>
                            
                            </Card>
                        )
                })
            )
        }
    
    render () {
        const {classes, canidates } = this.props
      
        return (
            <div>
            
            <Paper className={classes.paper}>
                <Typography variant="headline" color='primary' gutterBottom>
                    Weitere Helfer (Angebot)
                </Typography>
                {canidates
                    ? this.renderCanidates()
                    : null
                }
            </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    canidatesIds: state.adminCanidateState.currentOpenEvent.canidates,
    canidates: state.adminCanidateState.canidates

})

const mapDispatchToProps = (dispatch) => ({
    onFetchCanidates: (canidatesIds)=>fetchCanidates(canidatesIds),
    onSelectCanidate: (selectedCanidate)=>dispatch({type: SELECTED_CANIDATE, payload: selectedCanidate})

})


export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
    )(AltCanidateSelect)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AdminConnectedEvents/AdminConnectedEventsDetails/AltCanidateSelect.js